import { render, staticRenderFns } from "./GoalPage.vue?vue&type=template&id=04e8d8d0&scoped=true&lang=pug"
import script from "./GoalPage.vue?vue&type=script&lang=js"
export * from "./GoalPage.vue?vue&type=script&lang=js"
import style0 from "./GoalPage.vue?vue&type=style&index=0&id=04e8d8d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e8d8d0",
  null
  
)

export default component.exports